/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { ErrorOutline, Home } from '@mui/icons-material';
import { Link } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container maxWidth="sm" sx={{ mt: 8 }}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            textAlign="center"
            gap={3}
          >
            <ErrorOutline sx={{ fontSize: 64, color: '#e42200' }} />
            <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', color: '#e42200' }}>
              Oops! Something went wrong
            </Typography>
            <Typography variant="body1" color="text.secondary">
              We apologize for the inconvenience. Please try refreshing the page or return to our homepage.
            </Typography>
            <Box display="flex" gap={2}>
              <Button 
                variant="contained" 
                onClick={() => window.location.reload()}
                sx={{ backgroundColor: '#e42200', '&:hover': { backgroundColor: '#ff2600' } }}
              >
                Refresh Page
              </Button>
              <Button
                component={Link}
                to="/Home"
                variant="outlined"
                startIcon={<Home />}
                sx={{ 
                  color: '#e42200', 
                  borderColor: '#e42200',
                  '&:hover': { borderColor: '#ff2600', color: '#ff2600' }
                }}
              >
                Go Home
              </Button>
            </Box>
          </Box>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
